<template>
    <div>
        <v-container fluid>
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>
            <v-card class="box">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Suggesions Reports</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                </v-toolbar>
                <br>
                <v-row dense justify="center">
                    <v-radio-group v-model="radios" mandatory row class="ma-2 no-display">
                        <v-radio label="Feedbacks Count" value="count" color="#0f2027"
                            @change="feedbacklist = []"></v-radio>
                        <v-radio label="Resolved Feedbacks" value="resolved" color="#0f2027"
                            @change="feedbacklist = []"></v-radio>
                    </v-radio-group>
                </v-row>
                <v-row justify="center" dense>
                    <v-btn class="button mt-3" v-if="category && from_date && to_date" @click="getData()"
                        :loading="loader">Proceed</v-btn>
                </v-row>
                <v-row dense justify="center">
                    <v-col cols="12" sm="1"></v-col>
                    <v-col cols="12" sm="2">
                        <v-text-field outlined dense type="date" v-model="fromdate" label="From Date"
                            hint="From Date"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="2">
                        <v-text-field outlined dense type="date" v-model="todate" label="To Date"
                            hint="To Date"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="2">
                        <v-btn @click="getData()" :loading="loader" color="info">Fetch</v-btn>
                    </v-col>
                </v-row>
            </v-card>

            <v-card class="box" dense v-if="radios == 'count' && feedbacklist != ''">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Suggesions Count</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                </v-toolbar>
                <v-data-table :headers="headers_count" :items="feedbacklist" class="elevation-1 mytable">
                </v-data-table>
            </v-card>


            <v-card class="box" dense v-if="radios == 'resolved' && feedbacklist != ''">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Suggesions Resolved Count</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                </v-toolbar>
                <v-data-table :headers="headers_resolved" :items="feedbacklist" class="elevation-1 mytable">
                </v-data-table>
            </v-card>


        </v-container>
    </div>
    <!-- /. root div -->
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    data: () => ({
        loader: false,
        radios: null,
        fromdate: new Date(new Date().getFullYear(), new Date().getMonth() - 0, 2).toISOString().substr(0, 10),
        todate: new Date().toISOString().slice(0, 10),
        color: "",
        snackbar: false,
        dialog: false,
        aws_path: null,
        feedbacklist: [],
        filterArr: [],
        headers: [
            { text: "Sr.No.", value: "srno" },
            { text: "Title", value: "title" },
            // { text: "Remark", value: "remark" },
            { text: "Category", value: "category" },
            { text: "Feedback Date", value: "feedback_date" },
            { text: "Standard", value: "standard" },
            //  { text: "Academic Year", value: "academicyear" },
            { text: "User", value: "user" },
            //   { text: "User Type", value: "usertype" },
            //  { text: "Description", value: "description" },
            //  { text: "File", value: "file" },
            { text: "Is Read ?", value: "read" },
            { text: "Edit", value: "edit_Remark" },
        ],
        headers_count: [
            { text: "Sr.No.", value: "srno" },
            { text: "User", value: "user" },
            { text: "No Of Feedbacks", value: "count" },
        ],
        headers_resolved: [
            { text: "Sr.No.", value: "srno" },
            { text: "Standard", value: "standard" },
            { text: "No. Of Feedbacks", value: "total_feedbacks" },
            { text: "No. Of Resolved Feedbacks", value: "resolved_count" },
        ],
        loader: false
    }),
    created() {
        this.aws_path = localStorage.getItem("awspath");
    },
    methods: {
        getData() {
            const data = {
                type: this.radios,
                fromdate: this.fromdate,
                todate: this.todate,
            };
            this.loader = true
            this.feedbacklist = []
            axios
                .post("/Feedback/getFeedbackReport", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.feedbacklist = res.data.feedbacklist;
                    } else if (res.data.flag == "NO") {
                        this.showSnackbar("#b71c1c", res.data.fmsg);
                    } else {
                        this.showSnackbar("#b71c1c", "Something Went Wrong...");
                    }
                    this.loader = false
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something Went Wrong..."); // show snackbar
                    this.loader = false
                })
                .finally(() => {
                    // 'use strict';
                    this.loader = false
                });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
    },
    mounted() {
        //this.onLoad();
        this.aws_path = localStorage.getItem("awspath");
    },
    created() {
        this.tenant = localStorage.getItem("EPS-tenant");
    },
};
</script>

<style scoped>
input[type="text"] {
    width: 100%;
    display: inline-block;
    border: 1px solid black;
    border-radius: 4px;
    box-sizing: border-box;
}

.select {
    width: 100%;
    display: inline-block;
    border: 1px solid black;
    border-radius: 4px;
    box-sizing: border-box;
}

input[type="date"] {
    width: 50%;
    display: inline-block;
    padding: 0.3rem;
    border: 1px solid gray;
    border-radius: 30px;
    box-sizing: border-box;
    padding-top: none !important;
    margin-top: none !important;
}

v-simple-table {
    white-space: nowrap !important;
    text-align: center;
    font-size: small;
}

.table-head-background {
    background-color: #fcc96f;
    color: #fff;
    font-weight: 700;
}

.tc-title {
    background-image: linear-gradient(-90deg, #fcc96f, #fcb63c);
    color: #fff;
    font-weight: 700;
    margin: 0px !important;
    padding: 0px !important;
}

.text-left {
    font-size: 14px;
    font-weight: bold;
}

.text {
    color: blue;
    font-weight: 600;
    font-size: 14px;
}

.card-container {
    overflow-x: hidden;
    overflow: hidden;
}

/* .mytable1 {
  padding: 5px !important;
  } */
.mytable1>>>td {
    font-size: 15px;
    /* background-color: red; */
    /* padding: 3px; */
    height: 6px;
}
</style>
